export default {
  name: 'Content section - 13',
  tab: 'content',
  type: 'content-side-by-syde-section',
  content: {
    title: 'Side by side content section',
    introtext:
      '<p>Nullam quis risus eget urna mollis ornare vel eu leo. Sed posuere consectetur est at lobortis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.&nbsp;</p><p>Curabitur blandit tempus porttitor. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Maecenas sed diam eget risus varius blandit sit amet non magna.</p><p>Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Etiam porta sem malesuada magna mollis euismod.</p>',
    image: '/storage/media/samples/ekrem-osmanoglu-D-nA17RxAOI-unsplash.jpg',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--secondary-color)',
    'background-image': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--accent-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'var(--accent-color)'
  },
  layout: {
    'content-container-fluid': '0',
    container: '1',
    'content-container-size': 'lg',
    'content-horizontal-alignment': 'center',
    'content-vertical-alignment': 'start',
    'image-size': 'md',
    'image-position': 'right',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0',
    'content-box-border-color': 'inherit'
  },
  advanced: {}
}
